export const GET_FR_DATES = 'GET_FR_DATES';
export const GET_DASH_BALANCE_INFO = 'GET_DASH_BALANCE_INFO';
export const GET_DASH_PAYMENT_INFO = 'GET_DASH_PAYMENT_INFO';
export const GET_DASH_DEPOSIT_INFO = 'GET_DASH_DEPOSIT_INFO';
